import { axiosMeedioClient } from './client';

interface StartMeetingResponse {
  started_at: string;
  /**
   * `true` when this call was the first-ever start of the current
   * occurrence. Use to emit `MEETING_STARTED` exactly once.
   */
  started_now: boolean;
}

export const startMeeting = async (meetingId: string): Promise<StartMeetingResponse> => {
  const { data } = await axiosMeedioClient.patch<StartMeetingResponse>(`/meetings/${meetingId}/start`, {});
  return data;
};
